export default "__VITE_ASSET__Y6aRQkTC__"